define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce", "moment", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1, moment_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GrazingPermit = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    class GrazingPermit extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalGrazingDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalGrazingDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaybillNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaybillNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HealthCertNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HealthCertNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Pic", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PicError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, GrazingPermit.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.GrazingType = (0, EntityUtil_1.toInt)(entity.GrazingType);
            a.GrazingArea = (0, EntityUtil_1.toFloat)(entity.GrazingArea);
            a.StartDt = b.StartDt;
            a.EndDt = b.EndDt;
            a.GrazingDays = (0, EntityUtil_1.toInt)(entity.GrazingDays);
            a.FinalStartDt = b.FinalStartDt;
            a.FinalEndDt = b.FinalEndDt;
            a.FinalGrazingDays = (0, EntityUtil_1.toInt)(entity.FinalGrazingDays);
            a.WaybillNo = b.WaybillNo;
            a.HealthCertNo = b.HealthCertNo;
            a.Pic = b.Pic;
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 500);
            this.addChangeEventAction("StartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("EndDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalStartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalEndDt", this.onChangeBatchFn.bind(this));
            if (this.Permit) {
                this.Permit.addChangeEventAction("FeeApplicationRule", this.onChangeBatchFn.bind(this));
                this.Permit.addChangeEventAction("FeePermitRule", this.onChangeBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, GrazingPermit.AliasName);
            this.reset();
            if (!this.IsMarkedForDeletion && this.Permit.IsActive && this.Permit.License.IsPendingApprovalOrApproved) {
                this._validate(validationState, recurseChildren);
                if (this.StartDt > this.EndDt) {
                    this.StartDtError = "Permit end date must not preceed its start date";
                    validationState.addError(this.StartDtError);
                }
                else {
                    this.StartDtError = "";
                }
                if (this.FinalStartDt > this.FinalEndDt) {
                    this.FinalStartDtError = "Actual Permit end date must not preceed its actual start date";
                    validationState.addError(this.FinalStartDtError);
                }
                else {
                    this.FinalStartDtError = "";
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "PermitId", "Permit Id");
                this.validateReqNumber(validationState, "GrazingType", "Grazing Type");
                this.validateReqDate(validationState, "StartDt", "Start Date");
                this.validateReqDate(validationState, "EndDt", "End Date");
                this.validateReqNumber(validationState, "GrazingDays", "Grazing Days");
                this.validateReqString(validationState, "Pic", "PIC of Originating Property");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                GrazingType: this.GrazingType,
                GrazingArea: this.GrazingArea,
                StartDt: this.StartDt,
                EndDt: this.EndDt,
                GrazingDays: this.GrazingDays,
                FinalStartDt: this.FinalStartDt,
                FinalEndDt: this.FinalEndDt,
                FinalGrazingDays: this.FinalGrazingDays,
                WaybillNo: this.WaybillNo,
                HealthCertNo: this.HealthCertNo,
                Pic: this.Pic,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onChange(change) {
            if (this.Permit) {
                this.disableChangeObserver();
                this.calculateDates(change);
                this.calculateFees();
                this.validate(true);
                this.enableChangeObserver();
            }
        }
        calculateDates(change) {
            if (!change) {
                return;
            }
            if (!this.Permit.License.IsPersistedStatePendingApprovalOrApproved) {
                if (change.name == "StartDt") {
                    this.EndDt = (0, moment_1.default)(this.StartDt).add(this.GrazingDays - 1, "days").valueOf();
                    this.FinalEndDt = this.EndDt;
                    this.FinalStartDt = this.StartDt;
                    this.GrazingDays = (0, moment_1.default)(this.EndDt).diff((0, moment_1.default)(this.StartDt), "days") + 1;
                    this.FinalGrazingDays = this.GrazingDays;
                }
                else if (change.name == "EndDt") {
                    this.GrazingDays = (0, moment_1.default)(this.EndDt).diff((0, moment_1.default)(this.StartDt), "days") + 1;
                    this.FinalGrazingDays = this.GrazingDays;
                    this.FinalStartDt = this.StartDt;
                    this.FinalEndDt = this.EndDt;
                }
            }
            else if (change.name == "FinalStartDt" || change.name == "FinalEndDt") {
                this.FinalGrazingDays = (0, moment_1.default)(this.FinalEndDt).diff((0, moment_1.default)(this.FinalStartDt), "days") + 1;
            }
        }
        calculateFees() {
            (0, EventManager_1.notify)("Calculating Fees");
            services_1.SrmsServiceManager.Instance.PermitApplication.calculateGrazingPermitFees(this.Permit.toJson()).then(res => {
                if (res) {
                    this.Permit.FeeApplication = res.FeeApplication;
                    this.Permit.FeePermit = res.FeePermit;
                    this.Permit.FeeTotal = res.FeeTotal;
                    this.Permit.FeeStateGov = res.FeeStateGov;
                    this.Permit.FinalFeeTotal = res.FinalFeeTotal;
                    this.Permit.FinalFeeStateGov = res.FinalFeeStateGov;
                }
            });
        }
    }
    exports.GrazingPermit = GrazingPermit;
    Object.defineProperty(GrazingPermit, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "GrazingPermit"
    });
    Object.defineProperty(GrazingPermit, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Grazing Permit"
    });
    Object.defineProperty(GrazingPermit, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "GrazingType", "GrazingArea", "StartDt", "EndDt", "GrazingDays", "FinalStartDt", "FinalEndDt", "FinalGrazingDays", "WaybillNo", "HealthCertNo", "Pic", "Shape"]
    });
    Object.defineProperty(GrazingPermit, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingPermit, "GrazingTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingPermit, "GrazingTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingPermit, "GrazingAreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingPermit, "StartDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the expected start date of the agistment"
    });
    Object.defineProperty(GrazingPermit, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingPermit, "EndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingPermit, "GrazingDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingPermit, "FinalStartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingPermit, "FinalEndDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the date that the agistment was completed"
    });
    Object.defineProperty(GrazingPermit, "FinalEndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingPermit, "FinalGrazingDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingPermit, "WaybillNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(GrazingPermit, "WaybillNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingPermit, "HealthCertNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(GrazingPermit, "HealthCertNoTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a Health Certificate Number"
    });
    Object.defineProperty(GrazingPermit, "HealthCertNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingPermit, "PicLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(GrazingPermit, "PicTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Property Identification Code of applicant's property"
    });
    Object.defineProperty(GrazingPermit, "PicReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "GrazingType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "GrazingTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "GrazingArea", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "GrazingAreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "EndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "EndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "GrazingDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "GrazingDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "FinalStartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "FinalStartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "FinalEndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "FinalEndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "FinalGrazingDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "FinalGrazingDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "WaybillNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "WaybillNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "HealthCertNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "HealthCertNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "Pic", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "PicError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingPermit.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingPermit.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingPermit.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingPermit.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingPermit.prototype, "onChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingPermit.prototype, "calculateDates", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingPermit.prototype, "calculateFees", null);
});
